/* tslint:disable:no-console */

import { register } from 'register-service-worker';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';

export enum States {
    CACHED = 'cached',
    ERROR = 'error',
    OFFLINE = 'offline',
    PENDING = 'pending',
    READY = 'ready',
    REGISTERED = 'registered',
    UPDATED = 'updated',
}

export interface Event {
    registration?: ServiceWorkerRegistration;
    state: States;
}

export const serviceWorker$ = new BehaviorSubject<Event>({ state: States.PENDING });

function emit(event: Partial<Event>) {
    serviceWorker$.pipe(take(1)).subscribe(e => serviceWorker$.next({ ...e, ...event }));
}

if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready(registration) {
            emit({ registration, state: States.READY });
        },
        registered(registration: ServiceWorkerRegistration) {
            emit({ registration, state: States.REGISTERED });
        },
        cached(registration: ServiceWorkerRegistration) {
            emit({ registration, state: States.CACHED });
        },
        updated(registration: ServiceWorkerRegistration) {
            emit({ registration, state: States.UPDATED });
        },
        offline() {
            emit({ state: States.OFFLINE });
        },
        error(error) {
            emit({ registration: undefined, state: States.ERROR });
            console.error('Error during service worker registration:', error);
        },
    });
}
